<template>
  <section
    class="
      layout/grid
      layout/margin:top:page:2
      layout/width:100%
    ">
    <h3
      class="
        $color/gray:767
        $typography/size:medium
        color
        layout/padding:left:page
        typography
      ">
      Collection galleries
    </h3>
    <div
      class="
        $typography/size:extra-large
        layout/grid
        layout/grid:gap:page
        layout/margin:top:page
        layout/padding:left:page
        layout/padding:right:page
      ">
      <h2
        class="
          typography
        ">
        {{ themeGroup.Subtitle }}
      </h2>
      <p
        class="
          $typography/size:medium
          layout/margin:top:clear
          typography
        ">
        {{ getDescriptions }}
      </p>
    </div>
    <ul
      class="
        @600/layout/grid:columns:2
        @600/layout/grid:gap:row:page
        layout/grid:gap:column
        layout/flex
        layout/margin:top
        layout/padding:bottom:cap:2
        layout/padding:left:page
        layout/padding:right:page
        layout/scroll:horizontal
        scrolling-container
      "
      style="
        --layout--grid--gap--column: 1.2rem;
        overflow-x: auto;
        overflow-y: hidden;
        --layout--margin--top: 24px;
      ">
      <themeListCard
        v-for="theme in themes"
        :key="theme.id"
        :theme="theme"
        :setHighlightedElement="setHighlightedElement"
        :showDrawer="showDrawer"
      />
    </ul>
    <artistSection
      v-if="artists.length"
      :artists="artists"
    />
  </section>
</template>

<script>
  import artistSection from './visit-guide-map-theme-group-artists.vue';
  import themeListCard from './visit-guide-map-theme-group-card.vue';
  import i18n from "../../utils/i18n";
  export default {
    data() {
      return {
        i18n: new i18n()
      }
    },
    props: { 
      themeGroup: Object,
      setHighlightedElement: Function,
      showDrawer: {
        type: Function,
        required: true
      }
    },
    components: {
      artistSection,
      themeListCard
    },
    computed: {
      themes() {
        return this.themeGroup?.themes || [];
      },
      artists() {
        return this.themeGroup?.artists || [];
      },
      getDescriptions() {
        return this.i18n.t(`visit__guide__exhibitions__description__floor_${this.themeGroup.Id}`)
      }
    },
  }
</script>